import { GameData, useGamePlatform, useGetDemoGame, useGetGame } from 'react-easyrocket';
import { useParams } from 'react-router';

export function useGetGameData() {
  const { demo, gameId } = useParams();
  const platformId = useGamePlatform();

  const {
    game: demoGame,
    isLoading: isDemoGameLoading,
    error: errorDemo
  } = useGetDemoGame({ platform_id: platformId, demo_game_id: demo ? gameId || '' : '' }, {});
  const {
    game: singleGame,
    isLoading: isGameLoading,
    error: errorGame
  } = useGetGame({ platform_id: platformId, game_id: !demo ? gameId || '' : '' }, {});
  return {
    game: demo ? (demoGame as GameData) : singleGame,
    isLoading: demo ? isDemoGameLoading : isGameLoading,
    error: demo ? errorDemo : errorGame
  };
}
